import Select from '../../shared/styledComponents/Select';
import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent(Select, 'selectionField', ['select']);